var React = require('react');

function ContentWebcam (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Webcam"),React.createElement("path",{"d":"M25.7,18.9c3.8,0,6.8,3,6.8,6.8c0,3.8-3,6.8-6.8,6.8c-3.8,0-6.8-3-6.8-6.8l0,0C18.9,21.9,21.9,18.9,25.7,18.9z\n\t M44.6,48c-10.9,9.3-27.1,9.3-38,0l-3.8,6.5C2,56,2.5,57.8,3.9,58.7c0.5,0.3,1,0.4,1.5,0.4h40.5c1.7,0,3-1.3,3.1-2.9\n\tc0-0.6-0.1-1.2-0.5-1.7L44.6,48z M25.7,0C11.5,0,0,11.5,0,25.7s11.5,25.7,25.7,25.7s25.7-11.5,25.7-25.7c0,0,0,0,0,0\n\tC51.4,11.5,39.9,0,25.7,0C25.7,0,25.7,0,25.7,0z M25.7,4.1c1.1,0,2,0.9,2,2s-0.9,2-2,2s-2-0.9-2-2S24.6,4.1,25.7,4.1z M25.7,39.1\n\tc-7.4,0-13.4-6-13.4-13.4s6-13.4,13.4-13.4s13.4,6,13.4,13.4S33.1,39.1,25.7,39.1L25.7,39.1z","key":1})]);
}

ContentWebcam.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 51.4 59.1","style":{"enableBackground":"new 0 0 51.4 59.1"},"xmlSpace":"preserve"};

module.exports = ContentWebcam;

ContentWebcam.default = ContentWebcam;
